// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lg-1";
export var messageSideRight = "_lg-2";
export var orderLookupBubbleContainer = "_lg-0";
export var submitButton = "_lg-3";